import * as pConst from "../consts/profiles-consts.js";
import * as wConst from "../consts/website-consts.js";
const initState = {
  ProfilesData: null,
  State: pConst.STATE_NEW,
  Filter: pConst.FILTER_NONE,
  Search: "",
  Include: "",
  Exclude: "",
  ChangeProfiles: false,
  Errors: [],
  LastPull: new Date(),
  HasMore:false
};

export const profileListReducer = (state=initState,action) => {
  try {
    const resetState = {
      ProfilesData: null,
      State: pConst.STATE_NEW,
      Filter: pConst.FILTER_NONE,
      Search: "",
      Include: "",
      Exclude: "",
      ChangeProfiles: false,
      Errors: [],
      LastPull: new Date(),
      HasMore:false
    };
    switch(action.type) {
      case wConst.RESET_STATE: {
        state = resetState;
        break;
      }
      case pConst.ACTION_CHANGE_PROFILES: {
        state = {...state, ChangeProfiles: true};
        break;
      }
      case pConst.ACTION_SEARCH_PROFILES: {
        state = {...state, Search: action.payload, Filter: action.payload};
        break;
      }
      case pConst.ACTION_FETCH_PROFILES: {
        break;
      }
      case pConst.ACTION_FILTER_PROFILES: {
        state = { ...state, Filter: action.payload }
        break;
      }
      case pConst.ACTION_FETCH_PROFILES_PENDING: {
        state = {...state, State: pConst.STATE_LOADING,  ChangeProfiles: false, Profiles: false, LastQuery: action.payload, HasMore: false};
        return state;
      }
      case pConst.ACTION_FETCH_PROFILES_FULLFILLED: {
        //if(state.Page && state.Page >= 1) {
        //  state = {...state, State: pConst.STATE_LOADED, ChangeProfiles: false, ...action.payload.Context, LastPull: new Date()};
        //  state.ProfilesData.Context = action.payload.Context;
        //  state.ProfilesData.Result = state.ProfilesData.Result.concat(action.payload.Result);
        //} else {
          state = {...state, State: pConst.STATE_LOADED, ProfilesData: action.payload, ChangeProfiles: false, ...action.payload.Context, LastPull: new Date()};
        //}
        break;
      }
      case pConst.ACTION_FETCH_PROFILES_REJECTED: {
        state = {...state, State: pConst.STATE_ERROR};
        state.Errors.push({
          Message: action.payload,
          Details: ""
        })
        break;
      }
      default: {
        break;
      }
    }
  } catch(ex){
    console.log(ex)
  }
  return state;
};


